var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('form-group',{attrs:{"name":_vm.formGroupNameToUse}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }